import censusControl from './control'

async function appLoader(name) {
  switch (name) {
    case 'mediaalpha':
      return import(/* webpackChunkName: "census/mediaalpha" */ './mediaalpha')
    case 'control':
    default:
      return Promise.resolve({ default: censusControl })
  }
}

export default appLoader
